import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const TERMS = [
  ['Sponsor / Operator', 'NinjAthlete (merchandise fulfillment) and Biohacker Network (eligibility determination), which have a commercial relationship.'],
  ['Eligibility', 'New paid Biohacker Network members on any tier (Network, Pro, or Elite) whose account is active and in good standing. Minimum age 18. Void where prohibited.'],
  ['Geographic restrictions', 'United States shipping addresses only.'],
  ['Promotion period', 'Begins upon launch approval; continues while supplies last or until modified or terminated.'],
  ['Qualifying requirement', 'One successful paid membership payment, followed by a 14-day refund and chargeback waiting period.'],
  ['Limit', 'One gift per person and per household. Households are identified by normalized shipping address.'],
  ['Eligible merchandise', 'Designated NinjAthlete shirts and hats (ordinary retail value $28–$32). Substitutions of equal or greater value may be made if an item is unavailable.'],
  ['Shipping and tax', 'Applicable taxes and shipping, if any, are displayed before you confirm redemption.'],
  ['Redemption window', 'Redemption links expire 90 days after the gift becomes available.'],
  ['Cancellation consequences', 'Refunds, chargebacks, or membership cancellation before the waiting period ends cancel unredeemed gifts. Already-redeemed gifts connected to refunded payments may be reviewed.'],
  ['Fraud and abuse', 'Duplicate accounts, resale, automated redemption, or other abuse voids eligibility.'],
  ['No cash value', 'The gift has no cash value and cannot be exchanged, transferred, or redeemed for cash.'],
  ['No effect on clinical eligibility', 'The gift is a marketing promotion for a paid membership. It has no connection to, and no effect on, any clinical evaluation, prescription decision, or treatment plan.'],
  ['No review requirement', 'The gift is never conditioned on a positive review, testimonial, social post, or endorsement. If you choose to review the program, disclose that you received complimentary merchandise.'],
  ['Privacy', 'Only the attribution data necessary to administer this promotion is shared between NinjAthlete and Biohacker Network. Sensitive medical information is never shared with NinjAthlete.'],
  ['Customer support', 'support@ninjathlete.com'],
];

export default function PromotionTermsGiftPage() {
  useEffect(() => {
    document.title = 'Biohacker Member Gift — Promotion Terms | NinjAthlete';
    let canon = document.querySelector('link[rel="canonical"]');
    if (!canon) { canon = document.createElement('link'); canon.rel = 'canonical'; document.head.appendChild(canon); }
    canon.href = 'https://ninjathlete.com/promotion-terms/biohacker-member-gift';
    return () => canon.remove();
  }, []);

  return (
    <article className="bg-[#0a0a0a] min-h-screen" data-testid="promotion-terms-page">
      <div className="max-w-3xl mx-auto px-5 py-16">
        <nav aria-label="Breadcrumb" className="text-zinc-500 text-xs mb-6">
          <Link to="/" className="hover:text-white">Home</Link> <span aria-hidden>›</span>{' '}
          <Link to="/peptide-subscription" className="hover:text-white">Peptide Subscription</Link> <span aria-hidden>›</span>{' '}
          <span className="text-zinc-300">Promotion Terms</span>
        </nav>
        <h1 className="text-white text-4xl sm:text-5xl mb-4" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
          Biohacker Member Gift — Promotion Terms
        </h1>
        <p className="text-amber-400 text-xs mb-10 border border-amber-500/30 bg-amber-500/[0.05] px-4 py-3" data-testid="terms-counsel-notice">
          Status: these terms are pending final review by counsel. The promotion will not launch until that review is complete.
        </p>
        <dl className="space-y-6">
          {TERMS.map(([term, def]) => (
            <div key={term} className="border-b border-zinc-800 pb-5">
              <dt className="text-white text-sm font-bold mb-1.5">{term}</dt>
              <dd className="text-zinc-400 text-sm leading-relaxed">{def}</dd>
            </div>
          ))}
        </dl>
        <Link to="/peptide-subscription" className="inline-block mt-10 text-[#C7FA3E] text-xs uppercase tracking-wider hover:underline" data-testid="terms-back-link">
          ← Back to Peptide Subscription Memberships
        </Link>
      </div>
    </article>
  );
}
